var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-100"},[(_vm.manageEventMode)?[_c('div',{staticClass:"alert alert-warning d-flex justify-content-between align-items-center"},[_c('label',{staticClass:"fs-6"},[_vm._v("업무가 가능한 시간을 표시하세요")]),_c('button',{staticClass:"btn btn-light",on:{"click":function($event){_vm.manageEventMode = false}}},[_vm._v(" 완료 ")])])]:_vm._e(),_c('full-calendar',{attrs:{"options":Object.assign({}, _vm.calendarOptions,
      {events: _vm.events,
      dateClick: _vm.dateClick,
      eventClick: _vm.eventClick,
      customButtons: {
        manageEvent: {
          text: '일정 관리',
          click: _vm.manageEventClick,
        },
      }})}}),_c('event-add-modal'),_c('event-detail-modal'),_c('work-time-add-offcanvas')],2)}
var staticRenderFns = []

export { render, staticRenderFns }